var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { List, styled, useControlled } from '@mui/material';
import MenuListContext from './MenuListContext';
var MenuListRoot = styled(List)({
    paddingTop: 4,
    paddingBottom: 4,
    boxShadow: '0px 4px 8px rgba(0,0,0, 0.16)',
    background: '#fff'
});
var MenuList = function (props) {
    var children = props.children, multiple = props.multiple, valueProp = props.value, _a = props.defaultValue, defaultValue = _a === void 0 ? multiple ? [] : undefined : _a, onChange = props.onChange, otherProps = __rest(props, ["children", "multiple", "value", "defaultValue", "onChange"]);
    var _b = useControlled({
        controlled: valueProp,
        default: defaultValue,
        name: 'MenuList',
        state: 'value',
    }), value = _b[0], seValue = _b[1];
    var handleChange = function (selectedValue) {
        var newSelected;
        if (multiple) {
            if (value.indexOf(selectedValue) !== -1) {
                newSelected = value.filter(function (id) { return id !== selectedValue; });
            }
            else {
                newSelected = value.concat(selectedValue);
            }
        }
        else {
            newSelected = selectedValue;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newSelected);
        seValue(newSelected);
    };
    var contextValue = {
        multiple: multiple,
        value: value,
        onChange: handleChange,
    };
    return (React.createElement(MenuListContext.Provider, { value: contextValue },
        React.createElement(MenuListRoot, __assign({}, otherProps), children)));
};
MenuList.defaultProps = {};
export default MenuList;
